import re from './re'
import el from './el'
import pwdStrengt from './pwdStrengt'

export default {
  re,
  el,
  pwdStrengt,
}
